import { c as _c } from "react/compiler-runtime";
import { Avatar } from "@opensea/next-ui-kit";
import { Flex, Pill } from "@opensea/ui-kit";
import { useSwapProtocols } from "../currencies/activity/use-swap-protocols";
export function RelayerSearchPill(t0) {
  const $ = _c(19);
  let relayer;
  let rest;
  if ($[0] !== t0) {
    ({
      relayer,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = relayer;
    $[2] = rest;
  } else {
    relayer = $[1];
    rest = $[2];
  }
  const {
    getLogo,
    getName
  } = useSwapProtocols();
  if (relayer === "all") {
    let t1;
    if ($[3] !== rest) {
      t1 = <Pill {...rest}>All Relayers</Pill>;
      $[3] = rest;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  const t1 = relayer;
  let t2;
  if ($[5] !== getLogo || $[6] !== t1) {
    t2 = getLogo(t1);
    $[5] = getLogo;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const logo = t2;
  let t3;
  if ($[8] !== logo.icon) {
    t3 = logo.icon && <Avatar icon={logo.icon} size={11} />;
    $[8] = logo.icon;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = relayer;
  let t5;
  if ($[10] !== getName || $[11] !== t4) {
    t5 = getName(t4);
    $[10] = getName;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <Flex className="items-center gap-1.5">{t3}{t5}</Flex>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== rest || $[17] !== t6) {
    t7 = <Pill {...rest}>{t6}</Pill>;
    $[16] = rest;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}